<template>
	<div class="page">
		
		<div class="bottomView">
			<div class="leftButton">
				<el-input style="margin-right: 10px;" clearable placeholder="请输入内容" v-model="title" class="input-with-select">
				</el-input>
				<!-- <el-button type="primary">添加客户<i
								class="el-icon-arrow-down el-icon--down"></i></el-button>
						<el-button :disabled="!selection?.length">批量操作</el-button> -->
				<!-- <el-button type="primary">添加标签</el-button> -->
				<el-button type="primary" @click="getList">搜索</el-button>
			</div>
			<div class="rightButton">
				<!-- <el-button>导出 @size-change="handleSizeChange" @current-change="handleCurrentChange"</el-button> -->
				<el-pagination 
					:current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total,  sizes"
					:total="total">
				</el-pagination>
				<div class="page-wrapper">
					<el-button @click="prevPage" :disabled="page <= 1">‹</el-button>

					<div class="page-input">
						<el-input style="width: 70px;margin-right: 10px;" type="number" v-model.number="inputPage"
							@keyup.enter="jumpPage"></el-input>
						<span>/ {{ totalPage }}</span>
					</div>

					<el-button @click="nextPage" :disabled="page >= totalPage">›</el-button>
					<el-button type="primary" style="background-color: #2e4fed;border: 1px solid #2e4fed;" @click="addVisible({} ,false)"
						size="small">添加话术</el-button>
				</div>
			</div>
		</div>
		<div style="padding: 10px;">
			<el-button @click="handleDelete()" type="danger">删除</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" min-width="55">
				</el-table-column>
				<el-table-column fixed align="center" prop="title" label="标题" min-width="150">
				</el-table-column>
				<el-table-column align="center" prop="customer_service_id" label="接待会员" min-width="120">
				</el-table-column>
				<el-table-column align="center" prop="content" label="内容" min-width="450">
				</el-table-column>
				<!-- <el-table-column prop="status" label="状态" min-width="80">
				</el-table-column> -->
				<el-table-column align="center" prop="createtime" label="创建时间" min-width="120">
				</el-table-column>
				<el-table-column fixed="right" label="操作" min-width="120">
					<template slot-scope="scope">
						<el-button type="text" @click.native.prevent="addVisible(scope.row ,true)" size="small">
							详情
						</el-button>
						<el-button type="text" @click.native.prevent="addVisible(scope.row ,false)" size="small">
							编辑
						</el-button>
						<el-button type="text" @click.native.prevent="handleDelete(scope.row ,false)" style="color: red;"  size="small">
							删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<addPage :visible.sync="visible" @getList="getList" :row="row" :isOnlyRead ="isOnlyRead"></addPage>

		<el-dialog title="确定删除吗" :visible.sync="deleteVisible" width="30%" :before-close="handleClose">
			<span>这是一段信息</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="deleteVisible = false">取 消</el-button>
				<el-button type="primary" @click="deleteVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import addPage from './components/addPage.vue'
	export default {
		components: {
			addPage,
		},
		data() {
			return {
				visible: false,
				deleteVisible: false,
				type: 1,
				row: {},
				activeName: 'visitorTag',
				page: 1,
				inputPage: 1,
				pageSize: 10,
				total: 40,
				totalPage: 4,
				keyword:'',
				tableData: [],
				isOnlyRead: false,
				selection:[],
				title:'',
				// tabList: [{
				// 		name: 'visitorTag',
				// 		label: '会话列表'
				// 	},
				// 	{
				// 		name: 'history',
				// 		label: '搜索会话历史'
				// 	},
				// ]
			};
		},
		methods: {
			handleSelectionChange(val) {
				this.selection = val;
			},
			prevPage() {
				if (this.page > 1) this.page--
				this.inputPage = this.page
				this.getList()
			},
			nextPage() {
				if (this.page < this.totalPage) this.page++
				this.inputPage = this.page
				this.getList()
			},
			jumpPage() {
				let p = this.inputPage
				if (p < 1) p = 1
				if (p > this.totalPage) p = this.totalPage
				this.page = p
			},
			async getList() {
				const res = await this.$axios.get(this.$apis.getWordingList, {
					page: this.page,
					limit: this.pageSize,
					title:this.title
				})
				if (res.code == 1) {
					this.tableData = res.data.list
					this.total = res.data.total
					this.totalPage = Math.ceil(this.total / this.pageSize)
				}
			},
			handleClose(done) {
				this.$confirm('确认？')
					.then(() => {
						done();
					})
					.catch(() => {});
			},
			addVisible(row,type) {
				this.row = row
				this.isOnlyRead = type
				this.visible = true
			},
			handleDelete(row) {
				let ids = row?.id ?
					row.id :
					this.selection.map(item => item.id).join(',')
				if(!ids){
					this.$message.error('请至少选择一项!');
					return
				}
				this.$confirm('确认删除？')
					.then(() => {
						this.$axios.post(this.$apis.delWording, {
							ids: ids
						}).then(res => {
							if (res.code == 1) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.getList()
							} else {
								this.$message.error(res.msg);
							}
						})
					})
					.catch(() => {});
			},
		},
		mounted() {
			this.getList()
		}
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-tabs__item:hover {
		color: #2e4fed;
	}

	::v-deep .el-tabs__item.is-active {
		color: #2e4fed;
	}

	::v-deep .el-tabs__active-bar {
		background-color: #2e4fed;
	}

	.page {
		background-color: white;
		width: 100%;
		height: 800px;
		padding: 10px 20px;

		// ::v-deep .el-tabs__item.is-active {
		//     color: #2e4fed !important; /* 加上 !important 提高优先级 */
		// }

		// ::v-deep .el-tabs__item:hover {
		//     color: #2e4fed !important;
		// }

		// /* 底部蓝条 active-bar */
		// ::v-deep .el-tabs__active-bar {
		//   background-color: #2e4fed !important;
		// }

		.bottomView {
			display: flex;
			// height: 50%;
			justify-content: space-between;
			align-items: center;
			font-size: 13px;

			.rightButton {
				display: flex;
				align-items: center;

				.page-wrapper {
					display: flex;
					align-items: center;
					height: 80%;

					.page-input {
						margin: 0px 10px;
						display: flex;
						align-items: center;
					}
				}
			}

			.leftButton {
				display: flex;
			}

		}

	}
</style>